import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/(landing)/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/(landing)/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/(landing)/components/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/(landing)/news/components/NewsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/application/components/HashRouter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/application/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/application/ThemeRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
